import { render, staticRenderFns } from "./ConfigsTable.vue?vue&type=template&id=4f7f5373&scoped=true"
import script from "./ConfigsTable.vue?vue&type=script&lang=js"
export * from "./ConfigsTable.vue?vue&type=script&lang=js"
import style0 from "./ConfigsTable.vue?vue&type=style&index=0&id=4f7f5373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f5373",
  null
  
)

export default component.exports